export default {"src":"/_next/static/media/no_hat_glass.d7b196e0.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};